// extracted by mini-css-extract-plugin
export default {"option-separator":"OptionSeparator_option-separator__kF9H5","separator":"OptionSeparator_separator__cCKzG"};